import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { ComboPromo, DiferenciaPromo, EcommerceGenericoService, MontoPromo, NxMPromo, PorcentajePromo, PromocionesEccomerce } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { MarianomGeneral } from '../../marianom-general.service';

@Component({
  selector: 'promocion-card',
  templateUrl: './promocion-card.component.html',
  styleUrls: ['./promocion-card.component.scss']
})
export class PromocionCardComponent implements OnInit {
  @Input() promocion: PromocionesEccomerce;


  tipoPromocion : string = '';
  cantidadPromocion : number = 0;
  constructor( public genServ : EcommerceGenericoService, private serv: MarianomGeneral) {
    this.genServ.getObservableSeAgregaronItemsAlCarrito().subscribe({
      next:aviso=>{
        //console.log('promocard aviso nuevo art')
        this.actualizarCantidadPromocion();
      }
    })
   }

  ngOnInit(): void {
    //console.log('promocion card',this.promocion)

    if(this.promocion instanceof PorcentajePromo){
      this.tipoPromocion = 'Porcentaje';
    }

    if(this.promocion instanceof MontoPromo){
      this.tipoPromocion = 'MontoPromo'
    }

    if(this.promocion instanceof DiferenciaPromo){
      this.tipoPromocion = 'DiferenciaPromo'
    }

    if(this.promocion instanceof NxMPromo){
      this.tipoPromocion = 'NxM'
    }

    if(this.promocion instanceof ComboPromo){
      this.tipoPromocion = 'Combo'
    }

    this.actualizarCantidadPromocion();
    setTimeout(() => {
      this.actualizarCantidadPromocion();
    }, 2000);
  }

  /**
   * El combo no tiene un unico articulo (getArticulo1() queda sin resolver),
   * por eso todo lo que depende de getArticulo1()/getCantidad1() se guarda
   * atras de este chequeo en vez de asumir que siempre existe.
   */
  private actualizarCantidadPromocion() {
    if (this.promocion.getArticulo1()) {
      this.cantidadPromocion = Math.floor(this.promocion.getArticulo1().getCantidad() / this.promocion.getCantidad1())
    } else {
      this.cantidadPromocion = this.promocion.getCantidad1();
    }
  }

  agregarACarrito( event : number){
    //console.log('promocion-card agregarACarrito' ,event)
    if (event > 0 && !this.serv.isloged()) {
      this.serv.abrirModalLogin();
      return;
    }
    this.promocion.getArticulo1().setCantidad(this.promocion.getArticulo1().getCantidad() + (event * this.promocion.getCantidad1()))
    this.genServ.sincronizarCarritoFrontyBack();
    this.promocion.getArticulo1().operacionesExtras();
    this.cantidadPromocion = Math.floor(this.promocion.getArticulo1().getCantidad()/this.promocion.getCantidad1())
  }

  agregarComboACarrito(event: number) {
    if (event > 0 && !this.serv.isloged()) {
      this.serv.abrirModalLogin();
      return;
    }
    this.promocion.agregarCantidad(event);
    this.genServ.sincronizarCarritoFrontyBack();
  }

  get ocultarPrecios (){
    return this.genServ.isOcultarPrecio()
  }

  /**
   * Una promo de Porcentaje por Categoria comparte una única instancia entre
   * TODOS los artículos de la categoría; articulo1 es apenas el primero que
   * resolvió contra el catálogo, no "el" producto de la promo. El botón
   * Agregar/contador de esta card sólo mueve la cantidad de ESE artículo
   * puntual, lo cual confunde (parece que agregás "la promo" cuando en
   * realidad agregás un producto arbitrario de la categoría). Se detecta
   * por tener más de un artículo resuelto, sin depender de exponer
   * condicion/valorcondicion en el front.
   */
  get esPromoCategoriaSinArticuloUnico(): boolean {
    return this.tipoPromocion === 'Porcentaje' && this.promocion.getArticulosItems().length > 1;
  }
}
